import { render, staticRenderFns } from "./AuthInput.vue?vue&type=template&id=3879cf14"
import script from "./AuthInput.vue?vue&type=script&lang=js"
export * from "./AuthInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports